import { render, staticRenderFns } from "./DepartmentStudentsGetEnrollmentsDialog.vue?vue&type=template&id=43acac70&scoped=true"
import script from "./DepartmentStudentsGetEnrollmentsDialog.vue?vue&type=script&lang=js"
export * from "./DepartmentStudentsGetEnrollmentsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43acac70",
  null
  
)

export default component.exports